import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/sale/types/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/sale/types/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/sale/types/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/sale/types/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/sale/types/delete',
        method: 'post',
        data
    })
}

